import React from 'react';
import { Panel, PanelTheme } from '../Panel';
import { ProgressSpinner } from '../ProgressSpinner';
import { DemoPage } from './common/DemoLayout';

export const ProgressSpinnerDemo: React.FC = () => {
    return (
        <div style={{ maxWidth: '500px' }}>
            <DemoPage title='Progress Spinner :'>
                <Panel
                    theme={PanelTheme.White}
                    width='88%'
                >
                    <ProgressSpinner />
                </Panel>
            </DemoPage>
        </div>
    );
};
